import { useController } from 'react-hook-form';

import ErrorMessage from '@/components/ErrorMessage';
import { ToggleGroup, ToggleGroupItem } from '@/components/ToggleGroup';
import { useMediaQuery } from '@/hooks';

import Label from './Label';
import { parseMessage } from './utils';

function FormToggle({
	name,
	label,
	id,
	control,
	disabled,
	required,
	errorMessageProps,
	defaultValue,
	options,
	...props
}) {
	const { field, fieldState } = useController({ name, control, disabled });
	const mdDown = useMediaQuery('mdDown');

	return (
		<div className="form-input relative w-full">
			{label && (
				<Label
					className="mb-[14px] whitespace-nowrap"
					htmlFor={id}
				>{`${label}${required ? '*' : ''}`}</Label>
			)}
			<ToggleGroup
				className="justify-start"
				type="single"
				variant="outline"
				defaultValue={field.value}
				onValueChange={field.onChange}
				{...field}
				{...props}
			>
				{options.map(option => {
					return (
						<ToggleGroupItem
							value={option.value}
							key={option.label}
							size={mdDown ? 'lg' : 'default'}
							checked={field.value === option.value}
						>
							<p>{option.label}</p>
						</ToggleGroupItem>
					);
				})}
			</ToggleGroup>
			{fieldState.error?.message && (
				<ErrorMessage {...errorMessageProps}>
					{parseMessage(fieldState.error.message)}
				</ErrorMessage>
			)}
		</div>
	);
}

export default FormToggle;
